import { useCallback } from 'react'

import {
  DEFAULT_CAMERA_POSITION,
  DEFAULT_CAMERA_TARGET,
} from 'Pods/ThreeDStudio/constants'
import useUpdateSessionSettings from 'Pods/ThreeDStudio/Hooks/useUpdateSessionSettings'
import { useViewerStore } from 'Pods/ThreeDStudio/Hooks/useViewerStore'
import { useViewerContext } from 'Pods/ThreeDStudio/Shared/ViewerContext/ViewerContext'

function useViewerControls() {
  const viewer = useViewerContext()
  const grid = useViewerStore(viewer, 'grid')
  const camera = useViewerStore(viewer, 'camera')
  const updateSessionSettings = useUpdateSessionSettings()

  const toggleGrid = useCallback(() => {
    const next = !grid?.visible
    viewer?.setGridSettings({ visible: next })
    updateSessionSettings({ showGrid: next })
  }, [viewer, grid, updateSessionSettings])

  const toggleAutoRotate = useCallback(() => {
    const next = !camera?.autoRotate
    viewer?.setCameraSettings({ autoRotate: next })
    updateSessionSettings({ autoRotate: next })
  }, [viewer, camera, updateSessionSettings])

  const resetCamera = useCallback(() => {
    viewer?.resetCamera()
    viewer?.setCameraSettings({ autoRotate: false })
    updateSessionSettings({
      autoRotate: false,
      cameraPosition: DEFAULT_CAMERA_POSITION,
      cameraTarget: DEFAULT_CAMERA_TARGET,
    })
  }, [viewer, updateSessionSettings])

  return {
    grid,
    camera,
    toggleGrid,
    toggleAutoRotate,
    resetCamera,
  }
}

export default useViewerControls
